// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1vq_e","content":"ManualTimeModal_content__P-gHY"};